import { toast } from "sonner";
import { api, errorText } from "@/lib/api";

/** Hands over to Stripe Checkout. The plan only changes once Stripe confirms the payment. */
export const startCheckout = async (planId) => {
  try {
    const { data } = await api.post("/billing/checkout", { plan: planId, origin_url: window.location.origin });
    window.location.href = data.checkout_url;
  } catch (err) {
    toast.error(errorText(err));
  }
};

/** Stripe's own page for changing the card, seeing invoices or cancelling. */
export const openPortal = async (planId) => {
  try {
    const { data } = await api.post("/billing/portal", { plan: planId, origin_url: window.location.origin });
    window.location.href = data.url;
  } catch (err) {
    toast.error(errorText(err));
  }
};
